<template>
	<div class="detail-setting-box">
		<div class="left-nav">
			<div class="flag-wrap" style="margin-top:40px">展示详情页</div>
		</div>
		<div class="form-box" v-loading="loading">
			<div class="editor-box">
				<div class="time">最新更新时间：<span v-html="form.updated_at"></span></div>
				<Editor v-model="form.desc" :folder="folder" />
			</div>
		</div>
	</div>
</template>
<script>
import Editor from '@/components/editor'
import axios from 'axios'
// import { qiniuToken } from '@/api/common'
import { getOssMsg } from '@/api/oss'
import OSS from 'ali-oss'
axios.defaults.headers.common['Content-Type'] =
	'application/x-www-form-urlencoded'
axios.defaults.headers.common['Accept'] = '*/*'
// const axiosInstance = axios.create({ withCredentials: false })
export default {
	components: { Editor },
	props: {
		goodsData: {},
		formData: {}
	},
	watch: {
		goodsData(v) {
			this.form.updated_at = v.updated_at
			this.form.desc = v.product_detail ? v.product_detail.desc : ''
			// let link = v.product_detail ? v.product_detail.desc : ''
			// axiosInstance.get(link).then(res => {
			// 	this.form.desc = res.data
			// })
		}
	},
	data() {
		return {
			loading: false,
			form: { desc: '', updated_at: '' },
			folder: 'sundry'
		}
	},
	created() {
		this.folder = this.$route.query.id ? this.$route.query.id : this.getDate()
	},
	methods: {
		clearForm() {
			this.form.desc = ''
		},
		getDate() {
			const date = new Date()
			return `${date.getFullYear()}${date.getMonth() > 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
				}${date.getDate() > 9 ? date.getDate() : '0' + date.getDate()}`
		},
		random_string(len) {
			len = len || 32
			var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
			var maxPos = chars.length
			var pwd = ''
			for (let i = 0; i < len; i++) {
				pwd += chars.charAt(Math.floor(Math.random() * maxPos))
			}
			return pwd
		},
		checkForm() {
			this.loading = true
			const blob = new Blob([this.form.desc], {
				type: 'text/plain;charset=utf-8'
			})
			getOssMsg().then(res => {
				const config = {
					accessKeyId: res.access_key_id,
					accessKeySecret: res.access_key_secret,
					stsToken: res.security_token,
					bucket: res.bucket,
					region: res.region
				}
				return new Promise(() => {
					const fileName = this.goodsData
						? `${this.goodsData.details_text}`
						: `supply/goods_content/${this.folder}/${this.random_string(10)}`
					let client = new OSS(config)
					client
						.multipartUpload(fileName, blob, {
							callback: {
								url: res.callback_url,
								host: res.callback_host,
								/* eslint no-template-curly-in-string: [0] */
								body: 'bucket=${bucket}&object=${object}&var1=${x:var1}',
								contentType: 'application/x-www-form-urlencoded',
								customValue: {
									var1: 'value1',
									var2: 'value2'
								}
							}
						})
						.then(results => {
							// console.log(results)
							this.loading = false
							const resUrl = `https://${res.cdn_domain}/` + results.name
							this.$emit('update:formData', { desc: resUrl })
							this.$emit('on-success')
						})
						.catch(() => {
							//上传失败
							this.loading = false
							this.$message.error('上传失败，请重新上传！')
						})
				})
			})
		}
	}
}
</script>
<style lang="scss" scoped>
@import 'src/styles/mixin.scss';

.detail-setting-box {
	border: 1px solid #ddd;
	width: 1100px;
	margin: 0 auto;
	display: flex;

	.left-nav {
		width: 180px;
		background-color: #fcfcfc;
		border-right: 1px solid #ddd;

		.flag-wrap {
			$h: 48px;
			height: $h;
			background-color: #9ea7b4;
			position: relative;
			color: #fff;
			font-size: 16px;
			display: flex;
			align-items: center;
			padding-left: 42px;

			&::before {
				content: '';
				position: absolute;
				width: 0;
				height: 0;
				border-top: 12px solid #fff;
				border-bottom: 6px solid transparent;
				border-left: 8px solid #fff;
				border-right: 8px solid #fff;
				top: 50%;
				transform: translateY(-50%);
				left: 20px;
			}

			&::after {
				content: '';
				position: absolute;
				width: 0;
				height: 0;
				top: 0;
				right: -$h/3;
				border-top: $h/2 solid transparent;
				border-bottom: $h/2 solid transparent;
				border-left: $h/3 solid #9ea7b4;
			}
		}
	}

	.form-box {
		flex: 1;
		padding-left: 90px;
		padding-top: 20px;

		.time {
			color: #999;
			margin-bottom: 20px;
		}

		.editor-box {
			width: 375px;
		}
	}
}
</style>
